import { gql } from '@apollo/client';

export const UPDATE_PRODUCTS_QUANTITY = gql`
  mutation UpdateProductsQuantity($input: UpdateProductsQuantityInput!) {
    updateProductsQuantity(input: $input) {
      success
      message
      updated_products {
        product_id
        old_quantity
        new_quantity
      }
    }
  }
`;
